import type { EntityState } from './types';

export function entityAnimationState(entity: EntityState, target: EntityState | null): { moving: boolean; attacking: boolean } {
  const edgeDistance = target ? Math.hypot(entity.position.x - target.position.x, entity.position.y - target.position.y) - entity.radius - target.radius : 0;
  return {
    moving: entity.movement !== 'static' && !entity.dead && entity.deployRemaining <= 0 && entity.windupRemaining === 0 && target !== null && edgeDistance > (entity.weapon?.range ?? 0),
    attacking: entity.windupRemaining > 0,
  };
}
